import InterviewContainer from './TreatmentInterviewContainer';
import { ITreatmentInterviewProps } from 'src/packages/polaris/types/interviews';

const TreatmentInterview = ({
  commonCauses,
  conditionName,
  formLocation,
  isEmbedded = false,
  slug,
  polarisProps,
  onQuestionDisplay,
  onQuestionSubmit,
}: ITreatmentInterviewProps) => {
  return (
    <InterviewContainer
      commonCauses={commonCauses}
      conditionName={conditionName}
      isEmbedded={isEmbedded}
      formLocation={formLocation}
      onQuestionDisplay={onQuestionDisplay}
      onQuestionSubmit={onQuestionSubmit}
      polarisProps={polarisProps}
      slug={slug}
    />
  );
};

export default TreatmentInterview;
